import { render } from "./CustomContainerQuery.vue?vue&type=template&id=5aa7d0ab&scoped=true"
import script from "./CustomContainerQuery.vue?vue&type=script&lang=js"
export * from "./CustomContainerQuery.vue?vue&type=script&lang=js"

import "./CustomContainerQuery.vue?vue&type=style&index=0&id=5aa7d0ab&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5aa7d0ab"]])

export default __exports__